import { useEffect, useRef, useState } from "react";

export default function LazyVideo({ src, poster, width = "100%" }) {
  const videoRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const INTRO_FOLDER = `${process.env.PUBLIC_URL}`;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 } // se charge quand 25% visible
    );

    if (videoRef.current) observer.observe(videoRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <video
      ref={videoRef}
      width={width}
      controls
      muted
      playsInline
      preload="metadata"
      poster={poster}
      style={{ display: "block" }}
      autoPlay={true}
    >
      {shouldLoad && <source src={INTRO_FOLDER + src} type="video/mp4" />}
      Votre navigateur ne supporte pas la vidéo.
    </video>
  );
}
